document.addEventListener('DOMContentLoaded', function () {
    const reasonInput = document.getElementById('addDonationModel_DonationReason');
    const donationOtherLabel = document.getElementById('donation-other-label');
    const reasons = document.getElementById('donation-reasons-other-options');

    if (!reasonInput || !donationOtherLabel || !reasons) return;

    let parsedReasons = {};
    try {
        parsedReasons = reasons.value ? JSON.parse(reasons.value) : {};
    } catch (e) {
        parsedReasons = {};
    }

    const updateOtherLabel = () => {
        const selectedReason = reasonInput.value;
        const reasonOther = parsedReasons[selectedReason];

        if (reasonOther) {
            donationOtherLabel.parentElement.style.display = 'block';
            donationOtherLabel.textContent = reasonOther;
        } else {
            donationOtherLabel.parentElement.style.display = 'none';
            donationOtherLabel.textContent = '';
        }
    };

    reasonInput.addEventListener('change', updateOtherLabel);
    updateOtherLabel();
});
